// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedPhotometerLimbus_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 0H0V4H2L2 2H4V0ZM22 4H24V0H20V2H22V4ZM24 24H20V22H22V20H24V24ZM0 20V24L4 24V22H2L2 20H0Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0H13V3.05493C17.1716 3.51608 20.4839 6.82838 20.9451 11H24V13H20.9451C20.4839 17.1716 17.1716 20.4839 13 20.9451V24H11V20.9451C6.82838 20.4839 3.51608 17.1716 3.05493 13H0V11H3.05493C3.51608 6.82838 6.82838 3.51608 11 3.05493V0ZM5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedPhotometerLimbus is a generated icon component.
 */
let IconMedPhotometerLimbus = IconMedPhotometerLimbus_1 = class IconMedPhotometerLimbus extends IconBaseElement {
    render() {
        return html `${IconMedPhotometerLimbus_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedPhotometerLimbus.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedPhotometerLimbus = IconMedPhotometerLimbus_1 = __decorate([
    customElement('zui-icon-med-photometer-limbus')
], IconMedPhotometerLimbus);
export { IconMedPhotometerLimbus };
